import React from 'react';
import g1 from '../../assets/images/g1.jpeg';
import g2 from '../../assets/images/g2.jpg';
import g3 from '../../assets/images/g3.jpg';
import g4 from '../../assets/images/g4.jpg';
import g5 from '../../assets/images/gallary/g5.jpg';
import g6 from '../../assets/images/gallary/g6.jpg';
import { Grid, Container } from '@mui/material';
const Gallery = () => {
	return (
		<div>
			<Container>
				{/* <!--galley start--> */}
				<section id='gallery' className='gallery'>
					<div
						style={{
							padding: 44,
							boxShadow: '0 1px 7px 0 rgba(0, 0, 0, 0.4)',
						}}>
						<div className='gallery-details'>
							<div className='gallary-header text-center'>
								<h2>top destination</h2>
							</div>
							{/* <!--/.gallery-header--> */}
							<div className='gallery-box'>
								<div className='gallery-content'>
									<Grid container spacing={2} className='filtr-container'>
										<Grid item xs={12} lg={6}>
											<div className='filtr-item'>
												<img
													src={g1}
													alt='portfolio image'
													style={{ width: '100%', borderRadius: 5 }}
												/>
												<div className='item-title'>
													<a href='#'>china</a>
													<p>
														<span>20 tours</span>
														<span>15 places</span>
													</p>
												</div>
												{/* <!-- /.item-title --> */}
											</div>
										</Grid>
										<Grid item xs={12} lg={6}>
											<div className='filtr-item'>
												<img
													src={g2}
													alt='portfolio image'
													style={{ width: '100%', borderRadius: 5 }}
												/>
												<div className='item-title'>
													<a href='#'>venuzuala</a>
													<p>
														<span>12 tours</span>
														<span>9 places</span>
													</p>
												</div>
												{/* <!-- /.item-title--> */}
											</div>
										</Grid>
										<Grid item xs={12} lg={4}>
											<div className='filtr-item'>
												<img
													src={g3}
													alt='portfolio image'
													style={{ width: '100%', borderRadius: 5 }}
												/>
												<div className='item-title'>
													<a href='#'>brazil</a>
													<p>
														<span>25 tours</span>
														<span>10 places</span>
													</p>
												</div>
												{/* <!-- /.item-title --> */}
											</div>
										</Grid>
										<Grid item xs={12} lg={8}>
											<Grid container spacing={2}>
												<Grid item xs={12} lg={6}>
													<div className='filtr-item'>
														<img
															src={g4}
															alt='portfolio image'
															style={{ width: '100%', borderRadius: 5 }}
														/>
														<div className='item-title'>
															<a href='#'>brazil</a>
															<p>
																<span>25 tours</span>
																<span>10 places</span>
															</p>
														</div>
														{/* <!-- /.item-title --> */}
													</div>
												</Grid>
												<Grid item xs={12} lg={6}>
													<div className='filtr-item'>
														<img
															src={
																'https://hips.hearstapps.com/hmg-prod/images/fairytale-town-of-hallstatt-austria-royalty-free-image-1570204697.jpg'
															}
															alt='portfolio image'
															style={{ width: '100%', borderRadius: 5 }}
														/>
														<div className='item-title'>
															<a href='#'>brazil</a>
															<p>
																<span>25 tours</span>
																<span>10 places</span>
															</p>
														</div>
														{/* <!-- /.item-title --> */}
													</div>
												</Grid>
												<Grid item xs={12} lg={6}>
													<div className='filtr-item'>
														<img
															src={
																'https://hips.hearstapps.com/hmg-prod/images/fairytale-town-of-hallstatt-austria-royalty-free-image-1570204697.jpg'
															}
															alt='portfolio image'
															style={{ width: '100%', borderRadius: 5 }}
														/>
														<div className='item-title'>
															<a href='#'>brazil</a>
															<p>
																<span>25 tours</span>
																<span>10 places</span>
															</p>
														</div>
														{/* <!-- /.item-title --> */}
													</div>
												</Grid>
												<Grid item xs={12} lg={6}>
													<div className='filtr-item'>
														<img
															src={
																'https://hips.hearstapps.com/hmg-prod/images/fairytale-town-of-hallstatt-austria-royalty-free-image-1570204697.jpg'
															}
															alt='portfolio image'
															style={{ width: '100%', borderRadius: 5 }}
														/>
														<div className='item-title'>
															<a href='#'>brazil</a>
															<p>
																<span>25 tours</span>
																<span>10 places</span>
															</p>
														</div>
														{/* <!-- /.item-title --> */}
													</div>
												</Grid>
											</Grid>
										</Grid>
										{/*  */}
									</Grid>
									{/* <!-- /.filtr-container--> */}
								</div>
								{/* <!-- /.gallery-content --> */}
							</div>
							{/* <!--/.galley-box--> */}
						</div>
						{/* <!--/.gallery-details--> */}
					</div>
					{/* <!--/.container--> */}
				</section>
				{/* <!--/.gallery--> */}
				{/* <!--gallery end--> */}
			</Container>
		</div>
	);
};

export default Gallery;
